export default __webpack_public_path__ + "images/c0e383c5367e8da159270e0fab20af7b-city_town.webp";